import React from "react";

import "./App.css";
import { Boxes } from "./Components/Boxes/Boxes";

function App() {
  return (
    <>
      <Boxes></Boxes>
    </>
  );
}

export default App;
